import { ContentFilters, ContentTopBar } from 'components';
import { TicketSelectionFilterForm } from 'features/transaction_list/component/ticket-selection-filter-form/ticket-selection-filter-form';
import { TicketSelFilterFormValues } from 'features/transaction_list/component/ticket-selection-filter-form/type';
import { useState } from 'react';
import { CompanyType } from 'types';

type TicketTopBarProps = {
  getInitialFilterValues: TicketSelFilterFormValues;
  handleFilter: (values: TicketSelFilterFormValues) => void;
};

export const TicketSelectionTopBar = ({
  getInitialFilterValues,
  handleFilter,
}: TicketTopBarProps) => {
  useState<CompanyType>();

  const formId = 'ticket-selection-filters-form';

  return (

    <>
      <ContentTopBar
        title={'Tickets List'}

      />

      <ContentFilters formId={formId}>
        <TicketSelectionFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
        />
      </ContentFilters>
    </>
  );
};
